import { CzechSuklRsAtcGroupResponse } from 'com.cogvio.pricemonitor.api';
import { getCzechSuklRsAtcGroups } from '~/libs/infrastructure/api/availability';

import { FiltersValue } from '../components/Filters';
import { buildAvailabilityParams } from './availabilityQueryParams';

const MAX_NAME_LENGTH = 80;
const DEFAULT_FOLDER_NAME = 'Dostupnost';

export interface GroupFolderNameSource {
	rs: string | null;
	atc: string;
}

export function formatGroupFolderName(group: GroupFolderNameSource): string {
	if (group.rs) {
		return `RS ${group.rs} ${group.atc}`;
	}

	return group.atc;
}

export function truncateName(name: string): string {
	if (name.length <= MAX_NAME_LENGTH) {
		return name;
	}

	return `${name.slice(0, MAX_NAME_LENGTH - 3).trimEnd()}...`;
}

export function buildFolderNameFromFilters(filters: FiltersValue): string {
	if (filters.rs.length > 0) {
		return truncateName(`RS ${filters.rs.join(', ')}`);
	}

	return DEFAULT_FOLDER_NAME;
}

export function buildFolderNameFromGroup(group: CzechSuklRsAtcGroupResponse | GroupFolderNameSource): string {
	return truncateName(formatGroupFolderName(group));
}

export function resolveFolderNameFromLoadedGroups(
	filters: FiltersValue,
	groups?: CzechSuklRsAtcGroupResponse[]
): string | null {
	if (filters.rs.length > 0) {
		return buildFolderNameFromFilters(filters);
	}

	if (filters.items.length === 0) {
		return DEFAULT_FOLDER_NAME;
	}

	const firstSelectedId = filters.items[0].id;
	const group = groups?.find((item) => item.id === firstSelectedId);

	if (group) {
		return buildFolderNameFromGroup(group);
	}

	return null;
}

export async function buildFolderNameFromFiltersAsync(filters: FiltersValue): Promise<string> {
	if (filters.rs.length > 0) {
		return buildFolderNameFromFilters(filters);
	}

	if (filters.items.length > 0) {
		try {
			const response = await getCzechSuklRsAtcGroups(buildAvailabilityParams(filters, 1, 1));
			const group = response.items[0];

			if (group) {
				return buildFolderNameFromGroup(group);
			}
		} catch {
			return DEFAULT_FOLDER_NAME;
		}

		return DEFAULT_FOLDER_NAME;
	}

	return DEFAULT_FOLDER_NAME;
}
